import { useState, useEffect } from 'react';
import { ArrowUpRight, ChevronDown } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowBackToDashboardButton } from '../../store/reducers';
import { useLanguage, getReviewUserDetailsTranslation } from '../../hooks/useLanguage';

export const ReviewUserDetails = ({ userData, navigate }) => {
  const dispatch = useDispatch();
  const company = useSelector(state => state.company);
  const [isSpanish] = useLanguage();
  const [isCompanyCollapsed, setIsCompanyCollapsed] = useState(true);

  useEffect(() => {
    const onExpand = () => setIsCompanyCollapsed(false);
    window.addEventListener('expandReviewUserDetailsCompany', onExpand);
    return () => window.removeEventListener('expandReviewUserDetailsCompany', onExpand);
  }, []);

  return (
    <div className="text-left mt-8 text-sm" id="review-user" data-nav-breadcrumb="Review Details">
      <div className="circle bg-default mb-2">
        <span className="text-white">2</span>
      </div>
      <div className={`flex justify-between gap-4  items-center ${isCompanyCollapsed ? 'mb-4' : 'mb-4'}`}>
        <h1 className='text-3xl font-bold'>{getReviewUserDetailsTranslation('reviewDetails', isSpanish)}</h1>
      </div>
      <div className={`flex justify-between gap-4 items-center cursor-pointer ${isCompanyCollapsed ? 'justify-between flex-shrink-0 w-fit bg-gray-100a pl-3a pr-2a pb-2a pt-1a rounded-full' : 'justify-end flex-1'}`}  onClick={() => setIsCompanyCollapsed(prev => !prev)}>
        <h1 className='text-xl font-bold truncate'>{getReviewUserDetailsTranslation('company', isSpanish)}</h1>
        <div className='flex items-center gap-2'>
        {!isCompanyCollapsed && (
          <div className='flex justify-end items-center gap-2 flex-shrink-0'>
            <button className='flex gap-2 items-center' onClick={() => {
              dispatch(setShowBackToDashboardButton(true));
              navigate("/user-management");
            }}>
              <p>{getReviewUserDetailsTranslation('update', isSpanish)}</p>
              <ArrowUpRight className='w-6 h-6' />
            </button>
          </div>
        )}
        <ChevronDown className={`size-7 flex-shrink-0 transition-transform p-1 bg-gray-100 rounded-full ${isCompanyCollapsed ? '-rotate-90 mt-1' : ''}`} />
        </div>
      </div>
      {!isCompanyCollapsed && (
        <div className='p-4 border-containera bg-gray-100 rounded-xl form mt-2'>
          <div className='flex gap-4'>
            <div className="form-group flex-1" id='nombre'>
              <label htmlFor="nombre">{getReviewUserDetailsTranslation('companyName', isSpanish)}</label>
              <p className='font-bold'>{company.nombre}</p>
            </div>
            <div className="form-group flex-1" id='correo_electronico'>
              <label htmlFor="correo_electronico">{getReviewUserDetailsTranslation('companyEmail', isSpanish)}</label>
              <p className=' font-bold'>{company.correo_electronico}</p>
            </div>
          </div>
          <div className='flex gap-4'>
            <div className="form-group flex-1" id='nif'>
              <label htmlFor="nif">{getReviewUserDetailsTranslation('nif', isSpanish)}</label>
              <p className='font-bold'>{company.nif}</p>
            </div>
            <div className="form-group flex-1" id='eori'>
              <label htmlFor="eori">{getReviewUserDetailsTranslation('eoriNumber', isSpanish)}</label>
              <p className=' font-bold'>{company.eori}</p>
            </div>
          </div>
          <div className="form-group" id='direccion'>
            <label htmlFor="direccion">{getReviewUserDetailsTranslation('address', isSpanish)}</label>
            <p className='font-bold'>{company.direccion}</p>
          </div>
          <div className='flex gap-4'>
            <div className="form-group flex-1" id='localidad'>
              <label htmlFor="localidad">{getReviewUserDetailsTranslation('city', isSpanish)}</label>
              <p className=' font-bold'>{company.localidad}</p>
            </div>
            <div className="form-group flex-1" id='codigo_postal'>
              <label htmlFor="codigo_postal">{getReviewUserDetailsTranslation('postalCode', isSpanish)}</label>
              <p className='font-bold'>{company.codigo_postal}</p>
            </div>
          </div>
          <div className='flex gap-4'>
          <div className="form-group flex-1" id='pais'>
            <label htmlFor="pais">{getReviewUserDetailsTranslation('country', isSpanish)}</label>
            <p className='font-bold'>{company.pais}</p>
          </div>
          <div className="form-group flex-1" id='aduana_habitual'>
            <label htmlFor="aduana_habitual">{getReviewUserDetailsTranslation('standardCustomsOffice', isSpanish)}</label>
            <p className='font-bold'>{company.aduana_habitual}</p>
          </div>
          </div>
        </div>
      )}
    </div>
  );
};